<template>
	<div class="chat chat-left chat-system">
		<div class="chat-avatar">
			<div class="avatar">
				<Avatar :size="40" :username="$theme.title"
					:src="null" />
			</div>
		</div>
		<div class="chat-body">
			<div class="chat-content" v-html="message">
			</div>
		</div>
	</div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons'
library.add(faMoneyBill)

import Avatar from '@/src/components/Avatar.vue'

export default {
	name: "chat-system-message",
	props: {
		message: {
			required: true,
			type: Object
		},
	},
	components: {
		Avatar,
		FontAwesomeIcon,
	},
}
</script>

<style lang="scss" scoped>
@import "@/src/styles/variables";

.chat-system {
	.chat-content {
    background-color: $dark-blue !important;
    color: $white !important;

    &:before{
      border-right-color: $dark-blue !important;
    }
	}
}
</style>
